// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

export interface ICreateAppointmentPayload {
  partner_slug: string;
  entity?: string;
  entity_ref?: string;
  topic: string;
  option: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  date: string;
  time: string;
  country: string;
  state?: string;
  message?: string;
}

export interface ITimeSlotsParams {
  topic: string;
  option: string;
  entity?: string;
  entity_ref?: string;
  country?: string;
  state?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppointmentsService extends ApiService {
  list(): Promise<any> {
    return this.get('/schedule/appointment').toPromise();
  }

  create(payload: ICreateAppointmentPayload): Promise<any> {
    return this.post('/schedule/appointment', payload, { withCredentials: true }).toPromise();
  }
  timeslots(timeSlotParams: ITimeSlotsParams): Promise<any> {
    return this.get('/schedule/timeslots', { params: timeSlotParams }).toPromise();
  }
  createRequest(payload: ICreateAppointmentPayload): Promise<any> {
    return this.post('/schedule/assist-support', payload, { withCredentials: true }).toPromise();
  }
}
